// Datos de Cursos Vortex para la Plataforma Web de AscensosApp Vortex

export const COURSE_PERIODS = [
  {
    id: 'p1',
    name: 'Periodo 1: Septiembre - Noviembre',
    shortName: 'Sep - Nov',
    months: 'Septiembre a Noviembre',
    badge: '🔔 Periodo Activo',
    active: true,
    description: 'Fase inicial de preparación teórica intensiva para el examen de ascenso.'
  },
  {
    id: 'p2',
    name: 'Periodo 2: Diciembre - Febrero',
    shortName: 'Dic - Feb',
    months: 'Diciembre a Febrero',
    badge: '📅 Próximo Periodo',
    active: false,
    description: 'Fase intermedia de consolidación reglamentaria y operativa.'
  },
  {
    id: 'p3',
    name: 'Periodo 3: Marzo - Mayo',
    shortName: 'Mar - May',
    months: 'Marzo a Mayo',
    badge: '🎯 Periodo Final de Repaso',
    active: false,
    description: 'Fase final de simulación y repaso intensivo previo a los exámenes de ascenso.'
  }
];

export const COURSE_CATEGORIES = [
  'Todos',
  'Conocimientos Marineros',
  'Legislación Naval',
  'Conocimientos Específicos',
  'Inglés'
];

export const COURSES_DATA = [
  {
    id: "curso_leyes_2026",
    title: "Legislación Naval y Marco Jurídico Militar 2026",
    description: "Curso completo para examen de ascenso naval. Análisis de Ley de Disciplina, Código de Justicia Militar, deberes navales y jurisprudencia castrense aplicada.",
    category: "Legislación Naval",
    periodId: "p1",
    periodName: "Septiembre - Noviembre",
    price: 449,
    priceCurrency: "MXN",
    billingCycle: "Bimestral",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=800&q=80",
    total_lessons: 4,
    duration_minutes: 180,
    is_published: true,
    lessons: [
      {
        id: "l_101",
        course_id: "curso_leyes_2026",
        title: "Lección 1: Ley de Disciplina de la Armada de México y Uso de la Fuerza",
        module: "Módulo 1: Fundamentos Legales",
        order: 1,
        video_url: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
        duration_seconds: 360,
        key_points: [
          "Aplicación estricta del Artículo 15 en misiones de seguridad marítima y patrullaje costero.",
          "Criterios de proporcionalidad en el uso de la fuerza legal de acuerdo con el derecho internacional.",
          "Documentación obligatoria en cadena de custodia de evidencia naval.",
          "Responsabilidades del Comandante de Unidad en intervenciones jurisdiccionales."
        ],
        pdf_resources: [
          {
            name: "Resumen_Leyes_y_Reglamentos_2026.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "2.4 MB"
          },
          {
            name: "Manual_de_Bolsillo_Art_15_Interdiccion.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.1 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es el principio fundamental que rige el uso legítimo de la fuerza según la legislación naval?",
            options: [
              "Proporcionalidad, legalidad y necesidad absoluta",
              "Discrecionalidad total del jefe de operativo",
              "Exclusivamente mandato judicial previo de 48 horas",
              "Aprobación verbal por radio en cada maniobra"
            ],
            correct_index: 0,
            explanation: "Toda intervención militar debe regirse por los principios rectores de proporcionalidad, legalidad y necesidad operativa."
          },
          {
            id: 2,
            question: "¿Qué documento debe elaborarse inmediatamente al realizar un aseguramiento en zona costera?",
            options: [
              "Registro de Cadena de Custodia y Acta de Aseguramiento",
              "Únicamente el parte diario meteorológico",
              "Notificación informal al supervisor de turno",
              "Ningún documento hasta arribar a puerto base"
            ],
            correct_index: 0,
            explanation: "La Cadena de Custodia es prioritaria para salvaguardar la validez legal de los elementos probatorios."
          }
        ]
      },
      {
        id: "l_102",
        course_id: "curso_leyes_2026",
        title: "Lección 2: Deberes Navales y Jerarquía en el Servicio",
        module: "Módulo 1: Fundamentos Legales",
        order: 2,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        duration_seconds: 420,
        key_points: [
          "Principio de subordinación y ejercicio responsable del mando según el reglamento militar.",
          "Procedimientos para la transmisión de órdenes en situaciones tácticas complejas.",
          "Código de disciplina, honor naval y lealtad institucional."
        ],
        pdf_resources: [
          {
            name: "Reglamento_General_Deberes_Navales.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "3.8 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Qué obligación impone el principio de subordinación en el servicio naval?",
            options: [
              "El estricto cumplimiento de órdenes legales dadas por el superior jerárquico",
              "La obediencia condicional según el turno de trabajo",
              "La consulta previa con el comité de unidad en cada orden",
              "La autonomía individual en todas las maniobras"
            ],
            correct_index: 0,
            explanation: "El servicio naval requiere disciplina coherente basada en el respeto a la jerarquía y el cumplimiento cabal de órdenes lícitas."
          }
        ]
      }
    ]
  },
  {
    id: "curso_marineros_2026",
    title: "Conocimientos Marineros y Maniobras de Abordo 2026",
    description: "Manual completo de marinería naval: nomenclatura del buque, cabuyería, aparejos, maniobras de fondeo, atraco y seguridad en la mar.",
    category: "Conocimientos Marineros",
    periodId: "p1",
    periodName: "Septiembre - Noviembre",
    price: 449,
    priceCurrency: "MXN",
    billingCycle: "Bimestral",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=800&q=80",
    total_lessons: 3,
    duration_minutes: 160,
    is_published: true,
    lessons: [
      {
        id: "l_201",
        course_id: "curso_marineros_2026",
        title: "Lección 1: Nomenclatura Náutica del Buque y Estabilidad",
        module: "Módulo 1: Marinería General",
        order: 1,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        duration_seconds: 400,
        key_points: [
          "Partes principales del casco: proa, popa, babor, estribor, obra viva y obra muerta.",
          "Conceptos de eslora, manga, puntal, calado y franco bordo.",
          "Centros de gravedad, de carena y altura metacéntrica inicial."
        ],
        pdf_resources: [
          {
            name: "Manual_Nomenclatura_Naval_y_Marineria.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "4.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Qué término define la parte sumergida del casco de un buque?",
            options: [
              "Obra viva o carena",
              "Obra muerta",
              "Franco bordo",
              "Línea de flotación superior"
            ],
            correct_index: 0,
            explanation: "La obra viva es la porción sumergida del buque por debajo de la línea de flotación."
          }
        ]
      },
      {
        id: "l_202",
        course_id: "curso_marineros_2026",
        title: "Lección 2: Cabuyería Náutica, Nudos Navales y Encapilladuras",
        module: "Módulo 1: Marinería General",
        order: 2,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
        duration_seconds: 450,
        key_points: [
          "Tipos de celeridad en amarras de nylon, polipropileno y acero.",
          "Elaboración paso a paso de nudos marineros: as de guía, llano, ballestrinque y margarita.",
          "Cuidado y conservación de la estantería de amarras."
        ],
        pdf_resources: [
          {
            name: "Guia_Nudos_Navales_y_Cabuyeria.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "3.2 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es el nudo marinero más seguro para formar una gaza fija en el extremo de un cabo?",
            options: [
              "As de guía",
              "Ballestrinque",
              "Nudo llano",
              "Margarita"
            ],
            correct_index: 0,
            explanation: "El As de guía es la gaza por excelencia en la marinería debido a su firmeza y facilidad para zafar incluso bajo gran tensión."
          }
        ]
      }
    ]
  },
  {
    id: "curso_especificos_2026",
    title: "Conocimientos Específicos Navales y Táctica Operativa 2026",
    description: "Preparación de temas técnicos de especialidad naval: armamento militar, propulsión naval, control de averías y operaciones en embarcaciones interceptoras.",
    category: "Conocimientos Específicos",
    periodId: "p1",
    periodName: "Septiembre - Noviembre",
    price: 449,
    priceCurrency: "MXN",
    billingCycle: "Bimestral",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80",
    total_lessons: 3,
    duration_minutes: 150,
    is_published: true,
    lessons: [
      {
        id: "l_301",
        course_id: "curso_especificos_2026",
        title: "Lección 1: Armamento Naval, Balística y Mantenimiento",
        module: "Módulo 1: Especialidad Naval",
        order: 1,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        duration_seconds: 410,
        key_points: [
          "Sistemas de armas navales portátiles y montados en cubierta.",
          "Normas de seguridad en el pañol de municiones y pruebas de temperatura.",
          "Mantenimiento preventivo y correctivo de piezas de artillería ligera."
        ],
        pdf_resources: [
          {
            name: "Manual_Armamento_Naval_2026.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "2.8 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es la regla primordial de seguridad al ingresar al pañol de municiones?",
            options: [
              "Verificar temperatura, ventilación y prohibición absoluta de elementos inflamables",
              "Ingresar con linternas no estancas",
              "Dejar abierta la escotilla durante la maniobra",
              "No registrar las entradas en el libro de pañol"
            ],
            correct_index: 0,
            explanation: "El control estricto de temperatura y eliminación de chispas es vital en la seguridad de pañoles de munición."
          }
        ]
      }
    ]
  },
  {
    id: "curso_ingles_2026",
    title: "Inglés Americano — Niveles I y II (American English Course)",
    description: "Curso de inglés americano estructurado por libros y puntos gramaticales: demostrativos, verbo to be, presente simple y progresivo, pasado, futuro, comparativos y vocabulario progresivo. Incluye reglas en español, ejemplos y drills en inglés, y flashcards de vocabulario.",
    category: "Inglés",
    periodId: "p1",
    periodName: "Septiembre - Noviembre",
    price: 449,
    priceCurrency: "MXN",
    billingCycle: "Bimestral",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?auto=format&fit=crop&w=800&q=80",
    total_lessons: 8,
    duration_minutes: 120,
    is_published: true,
    temas: [
      { id: "t_book1", title: "A. LEVEL I - Book 1: Demonstratives y verbo to be", order: 1, lessons: [] },
      { id: "t_book2", title: "B. LEVEL I - Book 2: Let's, interrogativos y presente progresivo", order: 2, lessons: [] },
      { id: "t_book3", title: "C. LEVEL I - Book 3: Presente simple y pasado del verbo to be", order: 3, lessons: [] },
      { id: "t_book4", title: "D. LEVEL I - Book 4: Pasado, can, must y permission", order: 4, lessons: [] },
      { id: "t_book5", title: "E. LEVEL I - Book 5: There + be, some/any, will y cuantificadores", order: 5, lessons: [] },
      { id: "t_book6", title: "F. LEVEL I - Book 6: Pronombres, would like e indefinidos", order: 6, lessons: [] },
      { id: "t_book7", title: "G. LEVEL II - Book 7: Comparativos, superlativos y use + gerund", order: 7, lessons: [] },
      { id: "t_book8", title: "H. LEVEL II - Book 8: Going to, possessive pronouns y may/might", order: 8, lessons: [] }
    ]
  }
];
